import {PRIVACY_POLICY, TERMS_OF_USE} from '@/constants/contacts'
import {useIsMobile} from '@/utils/hooks/useWindowSize'

import style from './AgreementText.module.scss'

export default memo<{
  noPadding?: boolean
  className?: string
}>(function AgreementText({noPadding, className}) {
  const isMobile = useIsMobile()

  return (
    <div
      className={clsx(style.Agreement, noPadding && style.NoPadding, className)}
      data-testid='agreement-text'
    >
      <span className={style.AgreementText}>
        By chatting with Innosearch AI, you agree to our{' '}
        <a href={TERMS_OF_USE} target='_blank' rel='noreferrer'>
          {isMobile ? 'ToS' : 'Terms of Service'}
        </a>{' '}
        and{' '}
        <a href={PRIVACY_POLICY} target='_blank' rel='noreferrer'>
          Privacy Policy
        </a>
      </span>
    </div>
  )
})
